import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio, Loader2 } from "lucide-react";
import { toast } from "sonner";

import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", { email, password });
            localStorage.setItem("ms_admin_token", data.access_token);
            toast.success("Connecté");
            navigate("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Identifiants invalides");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen flex items-center justify-center px-6 bg-black" data-testid="admin-login-page">
            <SEO title="Espace admin — Mon Séraphin" description="Connexion à l'espace administrateur." path="/admin/login" noindex />
            <div className="pointer-events-none absolute top-0 inset-x-0 h-[400px] bg-[radial-gradient(ellipse_at_top,rgba(245,183,84,0.1),transparent_70%)]" />
            <div className="relative w-full max-w-md">
                <div className="flex flex-col items-center text-center">
                    <Radio className="w-8 h-8 text-amber-400 neon-flicker" strokeWidth={1.5} />
                    <h1 className="mt-4 font-display text-3xl text-white font-light">Espace admin</h1>
                    <p className="mt-2 text-sm text-zinc-500">Studio Mon Séraphin</p>
                </div>

                <form
                    onSubmit={submit}
                    className="mt-10 rounded-2xl border border-white/10 bg-white/[0.02] p-8 space-y-5"
                >
                    <div>
                        <Label className="text-zinc-400 uppercase text-xs tracking-widest">Email</Label>
                        <Input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            required
                            className="mt-2 bg-black/40 border-white/10 text-white"
                            data-testid="admin-email-input"
                        />
                    </div>
                    <div>
                        <Label className="text-zinc-400 uppercase text-xs tracking-widest">Mot de passe</Label>
                        <Input
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            required
                            className="mt-2 bg-black/40 border-white/10 text-white"
                            data-testid="admin-password-input"
                        />
                    </div>
                    <Button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-amber-400 text-black hover:bg-amber-300 rounded-full"
                        data-testid="admin-login-submit"
                    >
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Se connecter"}
                    </Button>
                </form>
            </div>
        </main>
    );
}
